/**
* Function to frame custom page title on window for using it in Appd
*/
export const setCustomPageName = (pathname) => {
  window.customPageTitle = pathname;
};
   
/**
* Function to set custom user data obj on window for using it in Appd
*/
export const setCustomUserData = (userObj = {}) => {
  const { customUserData = {} } = window;
  window.customUserData = {
    ...customUserData,
    ...userObj,
  };
}